import { isStringEmpty } from '@shared/utils';
import { SVGPureIcon } from '@/ui';
import globalStore from '@/store/global';

function IconButton(props) {
  const { className, disabled, iconClassName, icon, size, children, onClick } = props;
  return (
    <button
      className={[
        'rounded-[8px]',
        'p-6px',
        'flex items-center gap-[4px]',
        globalStore.isDark ? 'hover:bg-primary' : 'hover:bg-[#F0F2F5]',
        className,
      ]}
      onClick={
        event => {
          if(disabled){
            return;
          }
          onClick?.(event);
        }
      }
    >
      <SVGPureIcon className={iconClassName} name={icon} size={size} />
      {typeof children === 'string' && !isStringEmpty(children) ? (
        <span className="text-[13px] text-primary-opacity text-opacity-60">
          {children}
        </span>
      ) : (
        children
      )}
    </button>
  );
}

export default IconButton;
